import React, {FC, useEffect} from "react";
import {useEmployeesTree} from "../../hooks/useEmployeesTree";
import {ReactFlowProvider,} from 'reactflow';
import {LocalSpinner} from "../../../../../newShared/components/Spinner";
import {Box} from "@mui/material";
import 'reactflow/dist/style.css';
import {EmployeesTreeComponent} from "../../components/employeesTreeComponent";
import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {EmployeesBarUnderOrgTree} from "../../components/employeesBarUnderOrgTree";
import {ReleaseEmployees} from "../../components/dialogs/releaseEmployees";
import {PageTitleAndActions} from "../../../../../newShared/components/pageTitleAndActions";

// import {ImportCsv} from "../../components/dialogs/importCsv";
import {UpdateEmployeeTreeNode} from "../../components/dialogs/updateEmployeeTreeNode";
import {DeleteEmployeeDialog} from "../../components/dialogs/deleteEmployeeDialog";
import {useSetBreadcrumbs} from "../../../../barsEnvironment/breadcrumbs/hooks/useBreadcrumbs";
import {PATH_LOCAL_EMPLOYEES} from "../../../../../newShared/constants";
import {PATH_LOCAL_EMPLOYEES_TREE} from "../../constants";
// import {CreateEmployeeStatus} from "../../components/dialogs/createEmployeeStatus";
// import {CreateDepartment} from "../../components/dialogs/createDepartment";
// import {CreateJobTitle} from "../../components/dialogs/createJobTitle";


export const EmployeesTree: FC = () => {
    const {t, tMenu} = useMainTranslation('', {keyPrefix: 'pathHRManagement.tree'});
    const {getTree, setTree, isLoading: {isLoadingTree}, fullView} = useEmployeesTree();

    //Controller and first loadData
    const controller = new AbortController();
    useEffect(() => {
        !isLoadingTree && getTree(controller.signal);
        return () => {
            setTree({clear: true})
            controller.abort()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useSetBreadcrumbs([
        {
            title: tMenu('HR Management'),
            path: PATH_LOCAL_EMPLOYEES
        },
        {
            title: tMenu('Organization tree'),
            path: PATH_LOCAL_EMPLOYEES_TREE
        }
    ]);

    return (
        <ReactFlowProvider>
            <Box display={"flex"} flexDirection={"column"} width={'100%'} height={'100%'} overflow={"hidden"}>
                <PageTitleAndActions
                    title={t('Organization tree')}
                    actions={[]}
                >
                    <EmployeesBarUnderOrgTree/>
                </PageTitleAndActions>

                <Box width={fullView ? '100vw' : '100%'} height={fullView ? '100vh' : '100%'}
                     padding={fullView ? '0 12px' : '0'}
                     bgcolor={'white'}
                     sx={{
                         position: fullView ? 'absolute' : 'relative',
                         left: '0',
                         top: '0',
                         zIndex: fullView ? 3000 : undefined
                     }}>

                    {isLoadingTree && (
                        <Box width={'100%'} height={'100%'} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                            <LocalSpinner/>
                        </Box>
                    )}

                    <EmployeesTreeComponent/>
                </Box>

                {/*<DeleteEmployee />*/}
                <DeleteEmployeeDialog isOnTree={true} />
                <UpdateEmployeeTreeNode />
                {/*<CreateEmployeeStatus />*/}
                {/*<CreateDepartment />*/}
                {/*<CreateJobTitle />*/}
                <ReleaseEmployees />
                {/*<ImportCsv />*/}
            </Box>
        </ReactFlowProvider>
    )
}